// Port of api/fuel/app/classes/insights/hindex/overview.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'overview',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var levels = Util.query(
            'SELECT * FROM log_user_hindex WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND user_id = ' + owner.get_id() +
            ' ORDER BY log_hindex DESC'
        )

        if (!levels.length) return {}

        var current = levels[0]
        var currentHindex = parseInt(current.log_hindex, 10)

        var gamesIndexMap = {}

        for (var i = 0; i < levels.length; i++) {
            var ids = Util.parse_id_list(levels[i].log_index_level)
            for (var j = 0; j < ids.length; j++) {
                gamesIndexMap[ids[j]] = true
            }
        }

        var gamesIndex = Object.keys(gamesIndexMap)

        var median = Util.query(
            'SELECT SUM(p.play_count) AS c FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id HAVING SUM(p.play_count) >= ' + currentHindex
        )

        var medianValues = []
        for (var mi = 0; mi < median.length; mi++) {
            medianValues.push(parseFloat(median[mi].c))
        }

        var overqualified = Util.query(
            'SELECT p.game_id as g FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id HAVING SUM(p.play_count) >= ' + (currentHindex * 2)
        )

        var near = Util.query(
            'SELECT p.game_id as g FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id HAVING SUM(p.play_count) = ' + (currentHindex - 1)
        )

        var currentIndexLevel = this._data.current.get_index_level()

        var retired = 0
        for (var ri = 0; ri < gamesIndex.length; ri++) {
            if (currentIndexLevel.indexOf(parseInt(gamesIndex[ri], 10)) === -1) {
                retired++
            }
        }

        var overview = {
            efficiency: parseFloat(this._data.track.get_efficiency()),
            retired: retired,
            near: near.length,
            overqualified: overqualified.length,
            median: Util.median(medianValues),
            bias: parseFloat(this._data.track.get_bias()),
            plays: parseFloat(this._data.track.get_share()),
            collection: parseFloat(this._data.track.get_coverage()),
            concentration: parseFloat(this._data.track.get_concentration())
        }

        return {
            overview: overview
        }

    }
})
